<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-date-picker class="picker" v-model="search.created_time" type="datetimerange" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" placeholder="选择时间范围" />
            <el-input class="input" v-model="search.settlement_no" style="width: 250px;margin-right: 10px;" placeholder="结算单号" clearable />
			<el-select class="select" v-model="search.state" clearable placeholder="状态">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-button plain @click="getSettlementLists(1)">筛选</el-button>
		</div>
		<el-table class="table_div" :data="tableData" :header-cell-style="tabStyle">
			<el-table-column label="排序" type="index" width="100" align="center"/>
			<el-table-column label="结算单">
				<template slot-scope="scope">
					<div class="col">
						<span>单号：{{scope.row.settlement_no}}</span>
						<span>结算：{{scope.row.supplier_company}}</span>
						<span>制单：{{scope.row.created_time}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品">
				<template slot-scope="scope">
					<span>{{scope.row.good_quatity}}</span>
				</template>
			</el-table-column>
			<el-table-column label="结算金额">
				<template slot-scope="scope">
					<span>{{scope.row.settlement_amount}}</span>
				</template>
			</el-table-column>
			<el-table-column label="状态">
				<template slot-scope="scope">
					<span>{{scope.row.state_text}}</span>
				</template>
			</el-table-column>
			<el-table-column label="结算时间">
				<template slot-scope="scope">
					<span>{{scope.row.settlement_time}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-button class="item_btn" size="mini" type="primary" v-if="scope.row.state == 1 && is_supplier" @click="open('settlementDocListModify', scope.row.settlement_id)">编辑</el-button>
					<el-button class="item_btn" size="mini" type="success" v-if="scope.row.state == 2 && is_supplier" @click="receive(scope.row.settlement_id)">到款</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--弹出层-->
		<Popup :name="name" :show="show" :type="id" @close='close'/>

        <div class="">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="search.page" :pageSize="search.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
    import {
		supplier,
	} from "../../../request/apis.js"
	export default {
		components:{
			Tip,
			Popup
		},
		data(){
			return{
				tip:'从货品销售统计列表发起结算，本页是已经发起结算的单据列表，状态跟款收款。',
				options: [{
					value: '1',
					label: '待结算'
				}, {
					value: '2',
					label: '已结算'
				}, {
					value: '3',
					label: '已结算已到款'
				}],
                total: 0,
				tableData: [],
				name:'',
                id: 0,
				show:false,
                search: {
                    page: 1,
                    limit: 10,
                    created_time: [],
                    settlement_no: '',
                    state: '',
                },
                is_supplier: false,
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
        mounted() {
            this.getSettlementLists();
            var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
            this.is_supplier = loginInfo.supplier_id > 0;
        },
		methods:{
            getSettlementLists(page){
                this.loading = true;
                this.search.page = page || this.search.page;
                supplier(this.search, 0).then(res => {
                    this.loading = false;
					if (res.code == 0) {
                        this.total = res.count;
						this.tableData = res.data;
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
            },
			open(name, id){
				this.name = name;
                this.id = id;
				this.show = true
			},
			close(){
				this.show = false
			},
            receive(id){
                this.$confirm('此操作将确认到款, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supplier({settlement_id: id}, 7).then(res => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.$message.success(res.msg);
                            this.getSettlementLists();
                        }else{
                            return this.$message.error(res.msg);
                        }
                    }).catch(err => {})
                }).catch(() => {
                    this.$message({ type: 'info', message: '已取消' });          
                });
            },
            handleCurrentChange(page) {
				this.search.page = page; //每次点击分页按钮，当前页发生变化
				this.getSettlementLists();
			},
		}
	}
</script>

<style scoped>
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin: 20px 0;
	}
	.col{
		display: flex;
		flex-direction: column;
	}
	.picker {
		width: 180px;
		margin-right: 13px;
	}
	.select {
		width: 130px;
		margin-right: 13px;
	}
	.el-button--mini {
		margin-right: 10px;
	}
	
	.item_btn {
		margin: 5px 5px 0 0;
	}
	.pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px
	}
</style>